<template>
    <div>
        <div v-if="title" v-t="title" />
        <div v-else-if="type === 'export'">
            {{ i18n.t('rights.usersInfoExport') }}
        </div>
        <div v-else>
            {{ i18n.t('rights.usersInfo') }}
        </div>
        <v-list>
            <v-list-item
                v-for="user in users"
                :key="user.id"
            >
                <template #prepend>
                    <v-avatar>
                        <v-img v-if="user.path" :src="'/be/'+user.path" alt=""/>
                        <v-icon v-else>
                            mdi-account
                        </v-icon> 
                    </v-avatar>
                    
                </template>
                <v-list-item-title>
                    {{ user.name }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    props: {
        module: {
            type: String,
            default: null
        },
        id: {
            type: [String, Number],
            default: null
        },
        i18n: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            default: 'edit'
        },
        title: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            users: [],
            cancelSource: null
        }
    },
    watch: {
        module () {
            this.loadData()
        }
    },
    created () {
        console.log(this.i18n)
        this.loadData()
    },
    methods: {
        loadData () {
            if (this.cancelSource) {
                this.cancelSource.cancel()
            }

            const CancelToken = axios.CancelToken
            this.cancelSource = CancelToken.source()

            axios.get(`/be/rights/users/${this.type}/${this.module}/${this.id}`, { cancelToken: this.cancelSource.token }).then((res) => {
                this.loading = false
                this.users = res.data
            })
        }
    }
}
</script>
